<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 17"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#AABAD4">
        <path
          d="M2 12c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm0-6c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm0-6c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z"
          transform="translate(-1376 -323) translate(280 208) translate(0 96) translate(1088 12) translate(8 8) translate(6)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'VerticalMoreIcon',
  props: {
    height: VueTypes.string.def('17'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
